import type { NavLinkComponentProps } from '@ui';
import { Link } from 'react-router';

/** Marks the direction of the next page change for the view transition CSS. */
export function markNavigation(direction: 'push' | 'pop' | 'fade' | 'native') {
  document.documentElement.dataset.nav = direction;
}

/** Adapts react-router's `Link` to the design system's link contract. */
export function RouterLink({
  href,
  children,
  transition,
  onClick,
  ...rest
}: NavLinkComponentProps) {
  return (
    <Link
      to={href}
      viewTransition
      {...rest}
      onClick={() => {
        markNavigation(transition ?? 'fade');
        onClick?.();
      }}
    >
      {children}
    </Link>
  );
}
